module.exports = (__webpack_public_path__ || '') + "static/images/favicon-52eab920d8d1e13c38db0a8eb88ea987.ico";